const PrimariesModule = () => import('./PrimariesModule.vue')
import PresidentialPrimariesMap from './views/presidential/PresidentialPrimariesMap.vue'

export const primariesModuleRoute2026 = {
    name: 'primaries-2026',
    path: '/primaries-2026',
    component: PrimariesModule,
    children: [
        {
            path: 'map',
            name: 'primaries.map-2026',
            component: PresidentialPrimariesMap,
            meta: {
                title: 'Presidential Primaries 2026 Map',
                requiresAuth: false
            }
        }
    ]
}
